import { Alert, Grid } from '@mui/material';
import SalesContactMobileForm from './FormsMobileView/SalesContract';
import { SalesContractFormInterface } from '../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/SslesContracyInterface';
import StepOne from './FormsMobileView/SalesContract/StepOne';
import StepTwo from './FormsMobileView/SalesContract/StepTwo';

const SalesContractForm = ({
    error,
    updateField,
    payload,
    loading,
    errors,
    shippingLines,
    corporatePartners,
    loadingCorporatepartners,
    setShowAddPartner,
    isLoadingShippingLines,
    commodityFields,
    updateCommodityField,
    removeCommodityField,
    addCommodityField,
    commoditiesList,
    isLoadingCommodities,
    setSignatureUrlBase64Exporter,
    signatureUrlBase64Exporter,
    activeStep,
    setActiveStep,
    showPreview,
    setShowPreview,
    onSaveOnlyAction
}: SalesContractFormInterface) => {
    return (
        <>
            <SalesContactMobileForm
                {...{
                    error,
                    updateField,
                    payload,
                    loading,
                    errors,
                    shippingLines,
                    corporatePartners,
                    loadingCorporatepartners,
                    setShowAddPartner,
                    isLoadingShippingLines,
                    commodityFields,
                    updateCommodityField,
                    removeCommodityField,
                    addCommodityField,
                    commoditiesList,
                    isLoadingCommodities,
                    setSignatureUrlBase64Exporter,
                    signatureUrlBase64Exporter,
                    activeStep,
                    setActiveStep,
                    onSaveOnlyAction,
                    showPreview,
                    setShowPreview
                }}
            />
            <div className='hidden lg:block form-container'>
                <div className='border-0 border-appcolorgreyfaint'>
                    {error !== null && (
                        <div className='mt-10 mb-4'>
                            <Alert severity='error'>{error}</Alert>
                        </div>
                    )}

                    <form>
                        <div>
                            <Grid container>
                                <StepOne
                                    {...{
                                        updateField,
                                        payload,
                                        corporatePartners,
                                        errors,
                                        loadingCorporatepartners,
                                        setShowAddPartner,
                                        shippingLines,
                                        isLoadingShippingLines,
                                        commodityFields,
                                        updateCommodityField,
                                        removeCommodityField,
                                        addCommodityField,
                                        commoditiesList,
                                        isLoadingCommodities
                                    }}
                                />
                                <StepTwo
                                    {...{
                                        setSignatureUrlBase64Exporter,
                                        signatureUrlBase64Exporter,
                                        updateField,
                                        payload
                                    }}
                                />
                            </Grid>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default SalesContractForm;
